import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // ApiError(401) should never be retried — the apiClient already did refresh-once.
        // ApiError(4xx other than 429) is terminal.
        // 429 + network errors retry once.
        const status = (error as { status?: number })?.status;
        if (status && status >= 400 && status < 500 && status !== 429) return false;
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
